import { IDENTITY_API_URL } from './config';
import { supabase } from './supabase';

export class ApiError extends Error {
    status: number;
    constructor (message: string, status: number) {
        super(message);
        this.status = status;
    }
}

export async function accessToken (): Promise<string> {
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
        throw new ApiError('Not signed in', 401);
    }
    return data.session.access_token;
}

// Calls the identity backend with the Supabase access token. providerToken goes along only on the first call after
// signing in: the backend then copies the Google/Microsoft profile into the user's metadata.
export async function callIdentity<T> (path: string, init: RequestInit & { providerToken?: string } = {}): Promise<T> {
    const { providerToken, ...rest } = init;
    const headers = new Headers(rest.headers);
    headers.set('Authorization', `Bearer ${await accessToken()}`);
    if (providerToken) {
        headers.set('x-provider-token', providerToken);
    }
    const response = await fetch(IDENTITY_API_URL + path, { ...rest, headers });
    const body = await response.text();
    if (!response.ok) {
        let message = body || response.statusText;
        try {
            message = (JSON.parse(body) as { message?: string }).message ?? message;
        } catch {
            // plain text error
        }
        throw new ApiError(message, response.status);
    }
    return JSON.parse(body) as T;
}

export interface SessionInfo {
    sessionHandle: string;
    userId: string;
    accessTokenPayload: { jwt: string; _jwtPName: string };
}

export const getSessionInfo = (providerToken?: string) => callIdentity<SessionInfo>('/sessioninfo', { providerToken });

export const getOtp = async () => (await callIdentity<{ otp: string }>('/jwt/otp')).otp;
